export const MAX_SELECTED_SERVICES = 5;
export const MAX_SELECTED_ACCESSORIES = 5;

export const MAX_MESSAGE_ROWS = 5;
